export const dashboardStats = [
  { label: 'Matriculados', value: '248', trend: '+12%', tone: 'blue' },
  { label: 'Média Presença', value: '87%', trend: '+5%', tone: 'green' },
  { label: 'Turmas Ativas', value: '12', trend: '+2', tone: 'amber' },
  { label: 'Relatórios Pendentes', value: '4', trend: 'Atenção', tone: 'red' },
];

export const moduleHighlights = [
  {
    title: 'Estrutura EBD',
    route: '/classes',
    summary: 'Turmas, departamentos e faixas etárias.',
    items: '12 turmas e 4 departamentos',
  },
  {
    title: 'Gestão de Alunos',
    route: '/alunos',
    summary: 'Matrículas, responsáveis e histórico por turma.',
    items: '248 alunos cadastrados',
  },
  {
    title: 'Gestão de Professores',
    route: '/professores',
    summary: 'Professores, auxiliares e distribuição por turma.',
    items: '18 professores ativos',
  },
  {
    title: 'Relatórios',
    route: '/relatorios',
    summary: 'Consolidados dominicais, mensais e por turma.',
    items: '9 modelos disponíveis',
  },
];

export const classes = [
  {
    id: 'bercario-samuel',
    title: 'Berçário de Samuel',
    category: 'Berçário',
    teachers: ['Aux. Marta Souza', 'Irmã Carla Menezes'],
    students: 9,
    avg: '91%',
    ageRange: '0 a 3 anos',
    gender: 'Mista',
    type: 'Normal',
    room: 'Sala 01',
    schedule: 'Domingos, 9h',
  },
  {
    id: 'primarios-promessa',
    title: 'Primários da Promessa',
    category: 'Primários',
    teachers: ['Pb. Daniel Gomes', 'Irmã Ester Rodrigues'],
    students: 21,
    avg: '84%',
    ageRange: '7 a 10 anos',
    gender: 'Mista',
    type: 'Normal',
    room: 'Sala 03',
    schedule: 'Domingos, 9h',
  },
  {
    id: 'adolescentes-cristo',
    title: 'Adolescentes em Cristo',
    category: 'Adolescentes (11-14 anos)',
    teachers: ['Diác. Samuel Oliveira', 'Aux. Felipe Santos', 'Lívia Mendes'],
    students: 15,
    avg: '68%',
    ageRange: '11 a 14 anos',
    gender: 'Mista',
    type: 'Normal',
    room: 'Sala 07',
    schedule: 'Domingos, 9h',
  },
  {
    id: 'bereanos',
    title: 'Bereanos',
    category: 'Adultos (26-59 anos)',
    teachers: ['Pr. Marcos Ferreira', 'Pb. Lucas Andrade'],
    students: 42,
    avg: '82%',
    ageRange: '26 a 59 anos',
    gender: 'Mista',
    type: 'Normal',
    room: 'Templo Sede',
    schedule: 'Domingos, 9h',
  },
  {
    id: 'classe-obreiros',
    title: 'Obreiros',
    category: 'Obreiros',
    teachers: ['Pr. Elias Nascimento', 'Ev. Daniel Barros'],
    students: 28,
    avg: '89%',
    ageRange: '18+',
    gender: 'Masculina',
    type: 'Obreiros',
    room: 'Auditório 02',
    schedule: 'Domingos, 8h',
  },
  {
    id: 'colaboradoras-fe',
    title: 'Colaboradoras da Fé',
    category: 'Colaboradores',
    teachers: ['Missionária Rebeca Silva', 'Irmã Joana Costa'],
    students: 24,
    avg: '86%',
    ageRange: '18+',
    gender: 'Feminina',
    type: 'Colaboradores',
    room: 'Sala 10',
    schedule: 'Domingos, 8h30',
  },
];

export const departments = [
  {
    id: 'infantil',
    name: 'Infantil',
    classes: 4,
    leader: 'Irmã Ester',
    tag: 'Crianças',
    description: 'Acompanha berçário, jardim e turmas primárias.',
    coordinator: 'Depto. de Educação Cristã',
  },
  {
    id: 'juvenil',
    name: 'Juvenil',
    classes: 3,
    leader: 'Pb. Davi',
    tag: 'Adolescentes',
    description: 'Focado em adolescentes e pré-jovens da congregação.',
    coordinator: 'Superintendência EBD',
  },
  {
    id: 'adultos',
    name: 'Adultos',
    classes: 5,
    leader: 'Pr. Marcos',
    tag: 'Adultos',
    description: 'Turmas regulares e temáticas para adultos.',
    coordinator: 'Secretaria EBD',
  },
  {
    id: 'formacao-ministerial',
    name: 'Formação Ministerial',
    classes: 2,
    leader: 'Pr. Elias',
    tag: 'Obreiros',
    description: 'Capacitação contínua de obreiros e liderança.',
    coordinator: 'Presbitério',
  },
  {
    id: 'apoio-ministerial',
    name: 'Apoio Ministerial',
    classes: 2,
    leader: 'Missionária Rebeca',
    tag: 'Colaboradores',
    description: 'Treinamento e acompanhamento de colaboradores.',
    coordinator: 'Coordenação de Apoio',
  },
];

export const classAgeGroups = [
  { id: 'all', label: 'Todas', range: 'Visão geral', total: classes.length },
  { id: '0-3', label: '0 a 3 anos', range: 'Berçário', total: 1 },
  { id: '7-10', label: '7 a 10 anos', range: 'Primários', total: 1 },
  { id: '11-14', label: '11 a 14 anos', range: 'Adolescentes', total: 1 },
  { id: '18+', label: '18+', range: 'Especiais', total: 2 },
  { id: '26-59', label: '26 a 59 anos', range: 'Adultos', total: 1 },
];

export const students = [
  {
    name: 'Ana Beatriz Lima',
    className: 'Primários da Promessa',
    guardian: 'Maria Lima',
    attendance: '100%',
    status: 'Aniversário em 3 dias',
  },
  {
    name: 'João Pedro Alves',
    className: 'Adolescentes em Cristo',
    guardian: 'Carlos Alves',
    attendance: '74%',
    status: '2 faltas consecutivas',
  },
  {
    name: 'Lívia Mendes',
    className: 'Bereanos',
    guardian: 'Rafael Mendes',
    attendance: '88%',
    status: 'Transferência recente',
  },
];

export const teachers = [
  {
    name: 'Diác. Samuel Oliveira',
    role: 'Professor',
    classes: ['Adolescentes em Cristo', 'Obreiros'],
    status: '2 turmas',
  },
  {
    name: 'Pr. Marcos Ferreira',
    role: 'Professor',
    classes: ['Bereanos'],
    status: '1 turma',
  },
  {
    name: 'Aux. Marta Souza',
    role: 'Auxiliar',
    classes: ['Berçário de Samuel'],
    status: '1 turma',
  },
  {
    name: 'Irmã Carla Menezes',
    role: 'Auxiliar',
    classes: ['Berçário de Samuel'],
    status: '1 turma',
  },
  {
    name: 'Pb. Daniel Gomes',
    role: 'Professor',
    classes: ['Primários da Promessa'],
    status: '1 turma',
  },
  {
    name: 'Irmã Ester Rodrigues',
    role: 'Auxiliar',
    classes: ['Berçário de Samuel', 'Primários da Promessa'],
    status: '2 turmas',
  },
  {
    name: 'Aux. Felipe Santos',
    role: 'Auxiliar',
    classes: ['Adolescentes em Cristo'],
    status: '1 turma',
  },
  {
    name: 'Lívia Mendes',
    role: 'Professora',
    classes: ['Adolescentes em Cristo'],
    status: '1 turma',
  },
  {
    name: 'Pb. Lucas Andrade',
    role: 'Professor',
    classes: ['Bereanos'],
    status: '1 turma',
  },
  {
    name: 'Pr. Elias Nascimento',
    role: 'Professor',
    classes: ['Obreiros'],
    status: '1 turma',
  },
  {
    name: 'Ev. Daniel Barros',
    role: 'Professor',
    classes: ['Obreiros'],
    status: '1 turma',
  },
  {
    name: 'Missionária Rebeca Silva',
    role: 'Professora',
    classes: ['Colaboradoras da Fé'],
    status: '1 turma',
  },
  {
    name: 'Irmã Joana Costa',
    role: 'Auxiliar',
    classes: ['Colaboradoras da Fé'],
    status: '1 turma',
  },
];

export const reportItems = [
  {
    title: 'Relatório Geral do Domingo',
    desc: 'Consolidado com presentes, faltas, visitantes e oferta.',
    meta: 'Última emissão em 13/04',
  },
  {
    title: 'Relatório por Turma',
    desc: 'Resumo detalhado com desempenho e observações por turma.',
    meta: '12 turmas disponíveis',
  },
  {
    title: 'Faltosos Recorrentes',
    desc: 'Lista automática de alunos com 3 faltas consecutivas.',
    meta: '7 alunos sinalizados',
  },
  {
    title: 'Mensal Oficial',
    desc: 'Fechamento por congregação com médias e totais oficiais.',
    meta: 'Prazo até 10/05',
  },
];
